exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__label___1kDmo{font-size:16px;font-family:PlayfairDisplay-Regular;letter-spacing:1px;color:#000;padding:6px 11px 6px 0}", ""]);

// exports
exports.locals = {
	"label": "style__label___1kDmo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/label/style.css
// module id = 696
// module chunks = 0